import { FloraButton, Flex } from '@grupoboticario/flora-react'

const actionStyle = {
  width: '100%',
  '& svg': {
    display: 'none'
  },

  '@tablet': {
    width: 'auto',
    '& svg': {
      display: 'initial'
    }
  }
}

const TableHeaderActions = ({ leftActions = [], rightActions = [], onActionClick = () => {} }) => (
  <Flex justify="space-between" wrap="wrap">
    <Flex css={actionStyle} gap="$1" justify="flex-start" wrap="wrap">
      {leftActions.map((action) => (
        <FloraButton isUppercase key={action.event} onClick={() => onActionClick(action.event)} variant="alt">
          {action.text}
        </FloraButton>
      ))}
    </Flex>
    <Flex css={actionStyle} gap="$1" justify="flex-end" wrap="wrap">
      {rightActions.map((action) => (
        <FloraButton
          disabled={action.isDisabled}
          isUppercase
          key={action.event}
          onClick={() => onActionClick(action.event)}
          hierarchy="tertiary"
          has="iconRight"
          icon={action.icon}
        >
          {action.text}
        </FloraButton>
      ))}
    </Flex>
  </Flex>
)

export default TableHeaderActions
